import axios from "axios";

const API = axios.create({
  //baseURL: "http://localhost:5000",
  baseURL: "https://api.cahayapiraditakaning.sch.id",
  timeout: 15000, // 🧠 penting biar tidak hang saat server error
});

/*
|--------------------------------------------------------------------------
| REQUEST INTERCEPTOR (TOKEN AUTO ATTACH)
|--------------------------------------------------------------------------
*/
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/*
|--------------------------------------------------------------------------
| RESPONSE INTERCEPTOR (GLOBAL ERROR HANDLING)
|--------------------------------------------------------------------------
*/
API.interceptors.response.use(
  (response) => response,
  (error) => {
    // optional: handle expired token
    if (error.response?.status === 401) {
      console.warn("Token expired / unauthorized");

      localStorage.removeItem("token");
      // optional redirect
      // window.location.href = "/admin/login";
    }

    return Promise.reject(error);
  }
);

export default API;